// GENERATO automaticamente da app/scripts/fetch-google-rating.mjs (prebuild). NON modificare a mano.
// Media e conteggio delle recensioni Google (Places API), pescati a build-time.
// value/count = null finché non è disponibile una API key: in quel caso il badge
// recensioni non viene mostrato (niente dati inventati). Vedi company.ts e l'audit GEO.
export const GOOGLE_RATING: { value: number | null; count: number | null } = {
  value: 4.6,
  count: 621,
}
